import { useSyncExternalStore } from 'react'

/* ------------------------------------------------------------------
   شمارِ پیام‌های خوانده‌نشدهٔ گفتگو — برای نشانِ منو
   ------------------------------------------------------------------
   قابِ Rocket.Chat (در `ChatFrameHost`) رویدادِ `unread-changed` را
   می‌گیرد و اینجا می‌نویسد؛ سایدبار می‌خواند. یک مخزنِ کوچک و نه
   Context، چون نویسنده و خواننده در دو شاخهٔ جدای درخت‌اند و این
   مقدار تنها چیزِ مشترکشان است.

   ⚠️ Rocket.Chat سه شکل می‌فرستد: عدد (یا `'999+'`)، `'•'` برای
   «خوانده‌نشده هست ولی شمارش ندارد»، و `''` برای «هیچ».
   ------------------------------------------------------------------ */

export type ChatUnread = number | 'dot'

let current: ChatUnread = 0
const listeners = new Set<() => void>()

export function setChatUnread(raw: unknown): void {
  let next: ChatUnread = 0

  if (raw === '•') {
    next = 'dot'
  } else {
    const n = typeof raw === 'number' ? raw : Number.parseInt(String(raw ?? ''), 10)
    next = Number.isFinite(n) && n > 0 ? n : 0
  }

  if (next === current) return
  current = next
  listeners.forEach((listener) => listener())
}

export function useChatUnread(): ChatUnread {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
    () => current,
  )
}
